// extracted by mini-css-extract-plugin
module.exports = {"suggestionsContainer":"suggestionsList_suggestionsContainer__2kxnZ","suggestion":"suggestionsList_suggestion__B4wNS"};